import { createReducer } from '../../utilities';
import { scope } from '../../../actions/app/mpt/stats';
import {
    REQUEST_STATS_MPT_CARDS,
    SUCCESS_FETCH_STATS_MPT_CARDS,
    FAIL_FETCH_STATS_MPT_CARDS
} from '../../../actions/entities/mpt/stats';

const initialStatsMPTCardsStatisticsState = {
    stats: null,
    info: {
        isFetching: false,
        needRefresh: true,
        updatedAt: null
    }
};

function requestMPTCardsStatistics(state) {
    return {
        ...state,
        info: {
            isFetching: true,
            needRefresh: false,
            updatedAt: null
        }
    };
}

function successFetchMPTCardsStatistics(state, action) {
    const { stats, receivedAt } = action;
    return {
        ...state,
        stats,
        info: {
            isFetching: false,
            needRefresh: false,
            updatedAt: receivedAt
        }
    };
}

function failFetchMPTCardsStatistics(state, action) {
    const { errors } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            errors
        }
    };
}

export default createReducer(initialStatsMPTCardsStatisticsState, {
    [REQUEST_STATS_MPT_CARDS]: requestMPTCardsStatistics,
    [SUCCESS_FETCH_STATS_MPT_CARDS]: successFetchMPTCardsStatistics,
    [FAIL_FETCH_STATS_MPT_CARDS]: failFetchMPTCardsStatistics,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/mpt/cardsStats.js